module.exports = __webpack_public_path__ + "img/logoLefts.9f8b8455.png";